import { ReactNode } from 'react'
import { Tooltip as AntdTooltip } from 'antd'
import { TooltipPlacement, TooltipTrigger, TooltipAlignConfig } from 'antd/lib/tooltip'
import cx from 'classnames'

import Styles from './Tooltip.module.scss'

type TooltipVariant = 'default' | 'gradient'

export const Tooltip = ({
  label,
  placement,
  trigger,
  children,
  mouseEnterDelay,
  className,
  overlayClassName,
  variant = 'default',
  align,
  onVisibleChange,
  getPopupContainer,
  displayArrow = false,
  visible = true,
}: {
  label: ReactNode
  placement: TooltipPlacement
  trigger?: TooltipTrigger
  children: ReactNode
  mouseEnterDelay?: number
  className?: string
  overlayClassName?: string
  variant?: TooltipVariant
  align?: TooltipAlignConfig
  onVisibleChange?: (visible: boolean) => void
  getPopupContainer?: () => HTMLElement
  displayArrow?: boolean
  visible?: boolean
}) => {
  return (
    <>
      {visible ? (
        <AntdTooltip
          overlayClassName={cx(Styles[`${variant}__overlay`], overlayClassName, {
            [Styles.arrowVisible]: displayArrow,
          })}
          title={label}
          placement={placement}
          trigger={trigger}
          mouseEnterDelay={mouseEnterDelay}
          className={className}
          align={align}
          onVisibleChange={onVisibleChange}
          getPopupContainer={getPopupContainer}
        >
          {children}
        </AntdTooltip>
      ) : (
        <>{children}</>
      )}
    </>
  )
}
